import type { SVGProps } from "react";
import { memo } from "react";
const Kendra = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#055F4E" />
        <stop offset="100%" stopColor="#56C0A7" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M14 34.001h47v-2H14zm22-18h25v-2H36zm-10 0h3v-2h-3zm-6 0h3v-2h-3zm-6 0h3v-2h-3zm42.713 34.33c0 3.581-2.805 6.386-6.385 6.386-3.581 0-6.387-2.805-6.387-6.386s2.806-6.387 6.387-6.387 6.385 2.805 6.385 6.387m2 0c0-4.703-3.684-8.387-8.385-8.387-4.703 0-8.387 3.684-8.387 8.387 0 4.702 3.684 8.386 8.387 8.386 4.701 0 8.385-3.684 8.385-8.386m11.274 17.656c.05-.371-.05-.684-.294-.928l-8.143-7.927a14.4 14.4 0 0 1-2.42 2.42l7.95 8.136c.612.613 1.572.222 2.198-.404.393-.393.651-.866.71-1.297m-19.66-5.375c6.772 0 12.28-5.51 12.28-12.281S57.1 38.049 50.327 38.049c-6.77 0-12.28 5.51-12.28 12.282 0 6.771 5.51 12.28 12.28 12.28m21.642 5.64c-.116.87-.57 1.739-1.277 2.446-.862.863-1.888 1.302-2.86 1.302a3.03 3.03 0 0 1-2.175-.905l-8.21-8.404a14.16 14.16 0 0 1-7.12 1.92c-7.873 0-14.28-6.406-14.28-14.28s6.407-14.282 14.28-14.282c7.874 0 14.28 6.408 14.28 14.282 0 2.593-.706 5.02-1.919 7.118l8.41 8.186c.698.698 1.005 1.624.871 2.617M14 42.002h21.92c.416-.7.87-1.372 1.382-2H14zM65 19v-7c0-.55-.448-1-1-1H11c-.552 0-1 .45-1 1v7zm2-7v36.703a16.6 16.6 0 0 0-2-6.27V21.002H10v43.002h30.33a16.8 16.8 0 0 0 3.442 2H9a1 1 0 0 1-1-1V12C8 10.345 9.346 9 11 9h53c1.653 0 3 1.346 3 3M33.764 48.002a17 17 0 0 0-.188 2H14v-2z"
      />
    </g>
  </svg>
);
const Memo = memo(Kendra);
export default Memo;
